var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-main"},[_c('page-pop-card'),_c('el-divider',{staticClass:"custom-divider"}),_c('div',{staticClass:"page-main-title"},[_vm._v("中国中检，打造真正的奢侈品鉴定团队")]),_c('page-search-form'),_c('page-tips')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }